import {
  TransferReminder,
  TransferReminderInput
} from '../../lib/types/models/transfer/transfer-reminder'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createTransferReminder(input: TransferReminderInput & { transferId: number }) {
  const { transferId, ...rest } = input

  return restApiClient
    .url(constructApiUrl(API.transfer.createReminder.url, { transferId }))
    .post<TransferReminder, TransferReminderInput>(rest)
}
